export default __webpack_public_path__ + "static/media/Plugs.3eadf0bd.svg";